export default __webpack_public_path__ + "static/features_banner@3x-fe119206e345deeb51ce7f7fa5a84162.jpg";